import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  title: {
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: "bold"
  },
  header: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    display: "flex",
    padding: "9px",
    backgroundColor: "#308CDB",
    border: "1px solid #20639D"
  },
  icon: {
    cursor: "pointer"
  },
  gridContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    width: "100%",
    backgroundColor: "#FFFFFF",
    padding: "9px",
  },
  footer: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "flex-end",
    display: "flex",
    marginTop: "20px"
  },
  button: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "15px",
    height: "40px",
    borderRadius: "8px",
    padding: "5px 8px",
    whiteSpace: "nowrap",
    marginLeft: "auto",
    marginTop: "24px"
  }
}));

export default styles;
